import { EditorState, convertToRaw } from 'draft-js';
import { DELIMITER } from './constants';

const convertToText = (editorState: EditorState) => {
  const contentState = editorState.getCurrentContent();
  const { blocks, entityMap } = convertToRaw(contentState);

  const blockText = blocks.map(block => {
    const { entityRanges } = block;
    let text = block.text;
    let offsetAdjustments = 0;

    entityRanges.forEach(entityRange => {
      const { offset, length, key } = entityRange;
      const entity = entityMap[key];

      if (entity.type === 'mention') {
        const { mention } = entity.data;
        const replacement = `<#U${mention.id}>`;

        const start = offset + offsetAdjustments;
        const end = start + length;
        const textToReplace = text.substring(start, end);

        text = text.replace(textToReplace, replacement);
        offsetAdjustments = offsetAdjustments + (replacement.length - length);
      }
    });

    return text;
  });

  return blockText.join(DELIMITER).trim();
};

export default convertToText;
